webClient.controller('AirPaymentBodyBlue', ['$scope', '$window', '$timeout', '$i18next', '$filter', 'tseApiClient', 'tseUtil', 'tseAirResultsHelper', 'trackingService', 'gtmProduct', 'omnitureService',
    function ($scope, $window, $timeout, $i18next, $filter, tseApiClient, tseUtil, airHelper, trackingService, gtmProduct, omnitureService) {
        $scope.getText = function (key) { return window.culture.texts[key]; };
        var searchUrl = $window.site.currentAirRequest.searchUrl + "?" + tseUtil.Location.getQueryString();

        var bkgData = tseUtil.Session.get('bkgData_' + $window.site.currentAirRequest.requestId);
        $scope.bkgData = bkgData;
        $scope.getTemplateUrl = $window.getTemplateUrl;
        window.$scope = $scope;
        window.displayBrandedFaresSummary = true;
        $scope.enableUpSellProducts = $window.enableUpSellProducts || $window.sessionStorage.getItem('forceUpsell') === 'true';
        $scope.accommodation = null;
        $scope.pspAccountId = null;
        $.getScript("/Global/js/widgets/mrfly-widget-loader.js").done(function () {

        });
        var hfields = null;
        $scope.isAirbus = $window.isAirbus;

        //Tracking
        try {
            //GTM
            if (trackingService.isActivated()) {
                trackingService.initDataLayer('checkout');
                trackingService.loadSessionData('step', 3);
                trackingService.setOption($scope.bkgData.bookingResponse.paymentMethod.paymentMethodName);
                trackingService.parseScope($scope);
                trackingService.pushDataLayer('step', 4);
            }

            //omniture
            if (omnitureService.isActivated()) {
                omnitureService.sendEvent(omnitureService.PURCHASE_4_VOL, omnitureService.FLIGHT_TUNNEL, null);
            }
        }
        catch (ex) {
            console.log(ex.message);
            $window.trackingError = ex.message;
        }

        $scope.init = function (pspAccountId) {
            $scope.pspAccountId = pspAccountId;
        }

        $scope.saveSentryData = function (paymentError, paymentLogWidgetType, message, requestId, purchaseId, paymentId, paymentMethod, bookingId) {
            Raven.captureException(message, {
                extra: {
                    Payment:
                    {
                        requestId: requestId,
                        purchaseId: purchaseId,
                        paymentId: paymentId,
                        paymentMethod: paymentMethod,
                        bookingId: bookingId,
                        site: window.site.partnerId,
                        step: 4
                    }
                },
                tags: {
                    paymentLogType: paymentError,
                    paymentLogWidgetType: paymentLogWidgetType,
                    requestId: requestId,
                    purchaseId: purchaseId,
                    paymentId: paymentId,
                    paymentMethod: paymentMethod,
                    bookingId: bookingId,
                    site: window.site.partnerId,
                    step: 4
                }
            })
        }

        $scope.LoadVueJsWidgets = function () {
            if ($scope.bkgData.accommodations && $scope.bkgData.accommodations.any()) {

                $.getScript("/Global/js/widgets/mrfly-widget-accommodation-info.js").done(function () {
                    //Get from session
                    var accommodationKey = 'accommodation_' + $scope.bkgData.accommodations[0].accommodationId;
                    var accommodationJson = $window.sessionStorage.getItem(accommodationKey);
                    var accommodation = JSON.parse(accommodationJson);

                    mrflyWidgets['mrfly-widget-accommodation-info'].locale = $window.lng.substring(0, 2);
                    mrflyWidgets['mrfly-widget-accommodation-info'].resources = i18next.store.data.dev.translation;
                    mrflyWidgets['mrfly-widget-accommodation-info'].accommodation = accommodation;
                    mrflyWidgets['mrfly-widget-accommodation-info'].siteType = window.site.type;
                    if ($scope.bkgData.agencyMarginHotel) {
                        mrflyWidgets['mrfly-widget-accommodation-info'].agencyMarginHotel = $scope.bkgData.agencyMarginHotel.value;
                    }
                })
                    .fail(function (jqxhr, settings, exception) {
                        console.log(exception);
                    });


                $.getScript("/Global/js/widgets/mrfly-widget-basket-total-price.js").done(function () {
                    mrflyWidgets['mrfly-widget-basket-total-price'].resources = i18next.store.data.dev.translation;
                    mrflyWidgets['mrfly-widget-basket-total-price'].price = $scope.bkgData.totalBasketPrice();
                })
                    .fail(function (jqxhr, settings, exception) {
                        console.log(exception);
                    });
            }
        };

        if (bkgData) {

            window.FLoading({ vAction: 'show' });

            $timeout(function () {  // has to be done asynchronously
                $("#frm-widget").hide();
            }, 0, false);

            bkgData.totalBasketPrice = function () {

                if ($scope.bkgData.accommodations && $scope.bkgData.accommodations.any()) {
                    return bkgData.prixTotal.value + bkgData.accommodations[0].totalPriceForcedPrice;
                } else {
                    return bkgData.prixTotal.value;
                }
            };

            var keyGenerated = "";
            keyGenerated = bkgData.request.requestId + "_" + bkgData.purchaseRequest.index + "_" + bkgData.purchaseRequest.group + "_" + bkgData.purchaseRequest.proposal;
            bkgData.bookingRequest = tseUtil.Session.get("bookingRequest_" + keyGenerated);
            if (bkgData.purchaseResponse.productIsTrain) $scope.hideInsurance = bkgData.purchaseResponse.productIsTrain;
            else $window.hideInsurance ? $scope.hideInsurance = true : $scope.hideInsurance = false;
            if (bkgData.bookingRequest != null && bkgData.bookingRequest.requestId == bkgData.request.requestId) {
                var _insuranceSelected = tseUtil.Session.get("insurancesSelected_" + keyGenerated);
                bkgData.insurancesSelected = _insuranceSelected;

                $scope.webProcessed = true;
                if ($window.enableUpSellProducts || $window.sessionStorage.getItem('forceUpsell') === 'true') {
                    $scope.LoadVueJsWidgets();
                }

                $scope.updateBookingSummary = function () {
                    $scope.$broadcast("onBookingSummaryUpdate");
                };

                $scope.$on("onBookingSummaryUpdateCompleted", function (event, args) {

                    if (bkgData.accommodations && bkgData.accommodations.any() && $scope.isAirbus) {
                        $scope.prixTotalWithoutMargin = { value: bkgData.prixTotalWithoutMargin.value + bkgData.accommodations[0].totalPriceForcedPrice };
                    }
                    else {
                        $scope.prixTotalWithoutMargin = bkgData.prixTotalWithoutMargin;
                    }
                });
                $scope.updateBookingSummary();

            }
            else {
                $window.FLoading({ vAction: 'show' });
                window.location.href = searchUrl;
            }

            //Taxes details click
            $scope.$on("displayTaxesDetailsClick", function (event, args) {
                $scope.displayTaxesDetailModal = true;
                $scope.modalTaxesKey = args.key.replaceAll(":", "-");
                $scope.modalTaxesKey = $scope.modalTaxesKey.replaceAll("\\|", "-");
                $scope.modalTaxesKeyAux = $scope.modalTaxesKey + "-" + args.paxFares.paxType;
                $scope.modalTaxesPaxFares = args.paxFares;

                $scope.modalShowMargin = false;

                var airlines = JSON.parse(window.sessionStorage.getItem("airlines"));

                args.marketingCarriers.each(function (value, key) {

                    if (airlines != null && airlines[value].showMargin == true || value === 'AF') {
                        $scope.modalShowMargin = true;
                    }
                });

                $scope.$broadcast("updateTaxesDetailModalData", { key: $scope.modalTaxesKey, fares: $scope.modalTaxesPaxFares });

                //Remodal workaround
                $(document).find(".remodal").each(function (a, c) {
                    var d = $(c), e = d.data("remodal-options");
                    e ? ("string" == typeof e || e instanceof String) && (e = j(e)) : e = {},
                        d["remodal"](e)
                });

                $timeout(function () {
                    $('[data-remodal-id=' + 'taxes-detail-modal-' + $scope.modalTaxesKeyAux + ']').remodal().open();
                },
                    200, false);
            });

            //Luggage details click
            $scope.$on("displayLuggageDetailsClick", function (event, args) {
                $scope.displayLuggageDetailModal = true;
                $scope.modalLuggageBagType = args.bagType;

                $scope.$broadcast("updateLuggageDetailModalData", { bagType: $scope.modalLuggageBagType });

                $scope.modalShowMargin = false;

                var airlines = JSON.parse(window.sessionStorage.getItem("airlines"));

                args.marketingCarriers.each(function (value, key) {

                    if (airlines != null && airlines[value].showMargin == true || value === 'AF') {
                        $scope.modalShowMargin = true;
                    }
                });

                //Remodal workaround
                $(document).find(".remodal").each(function (a, c) {
                    var d = $(c), e = d.data("remodal-options");
                    e ? ("string" == typeof e || e instanceof String) && (e = j(e)) : e = {},
                        d["remodal"](e)
                });

                $timeout(function () {
                    $('[data-remodal-id="luggage-detail-modal"]').remodal().open();
                },
                    200, false);
            });

            $scope.displayWidgetForm = function () {
                try {
                    console.log("initializing be2bill");
                    var amount = $scope.bkgData.totalBasketPrice();

                    if ($window.casinoTotalAmount) {
                        amount = $window.casinoTotalAmount;
                    }

                    if ($scope.isAirbus) {
                        amount = $scope.bkgData.bookingResponse.paymentAmount;
                    }

                    var submitText = $i18next.t('simplepayment.acceptandpay') + " " + $filter('number')(amount, 2) + " €";

                    console.log(submitText);

                    var cbOptions = {
                        "placeholder": { // placeholder of the input hosted fields
                            "holdername": $i18next.t('simplepayment.cardowner'),
                            "card": $i18next.t('simplepayment.cardnumber'),
                            "expiry": $i18next.t('simplepayment.date'),
                            "cryptogram": $i18next.t('simplepayment.ccv')
                        },
                        "labels": { // label of the hosted fields
                            "cardHolder": "",
                            "brand": "",
                            "card": "",
                            "expiry": "",
                            "validity": "",
                            "submit": submitText,
                        },
                        "style": { // define the style of the hosted-fields input
                            "card": {
                                "input": { // css syntax
                                    "font-family": "Arial,sans-serif",
                                    "font-size": "14px",
                                    "line-height": "43px",
                                    "background-color": "transparent"
                                }
                            },
                            "expiry": {
                                "input": { // css syntax
                                    "font-family": "Arial,sans-serif",
                                    "font-size": "14px",
                                    "line-height": "43px",
                                    "background-color": "transparent"
                                }
                            },
                            "cryptogram": {
                                "input": { // css syntax
                                    "font-family": "Arial,sans-serif",
                                    "font-size": "14px",
                                    "line-height": "43px",
                                    "background-color": "transparent"
                                }
                            },
                            "holdername": {
                                "input": { // css syntax
                                    "font-family": "Arial,sans-serif",
                                    "font-size": "14px",
                                    "line-height": "43px",
                                    "background-color": "transparent"
                                }
                            }
                        },
                        "submitCallback": function () {

                            //Tracking
                            try {
                                //GTM
                                if (trackingService.isActivated()) {
                                    trackingService.pushPageData('/Flightsearch/Payment/CBwait', 'Payment CB Wait', lng, false);
                                }
                            }
                            catch (ex) {
                                console.log(ex.message);
                                $window.trackingError = ex.message;
                            }

                            $window.site.pushNoBackOnHistory();
                            window.mrflyWidgets['airbooking-process-loader'].$store.commit("showLoader");

                            var hfToken = $("#hf-token").val();
                            var selectedBrand = $("#selected-brand").val();
                            var cardHolder = $('[name=card-holder-name]').val();
                            if (window.site.partnerId == "servair") {
                                var selectedProduct = window.sessionStorage.getItem("selectedProduct");
                                var bookingNumber = null;
                                var origineAirportIata;
                                var destinationAirportIata;
                                if ($scope.bkgData != null && $scope.bkgData.bookingResponse != undefined && $scope.bkgData.bookingResponse.numbers.length > 0) {
                                    bookingNumber = $scope.bkgData.bookingResponse.numbers[0].bookingNumber;
                                    origineAirportIata = bkgData.purchaseResponse.itineraries[0].origin.airportIata;
                                    destinationAirportIata = bkgData.purchaseResponse.itineraries[0].destination.airportIata;
                                }
                                var aireportIata = origineAirportIata + destinationAirportIata;
                                $window.Typescript.Servair.Services.ServairService.doPostTotal($scope.bkgData.request.requestId, $scope.bkgData.bookingResponse.bookingId, selectedProduct, bookingNumber, aireportIata).then(function (result) {
                                    if (result.data === true) {
                                        var result = window.Typescript.Services.OrderServiceService.ProcessOrder($scope.bkgData.request.requestId,
                                            $scope.bkgData.bookingRequest.purchaseId, $scope.bkgData.bookingResponse.bookingId,
                                            $scope.bkgData.bookingResponse.paymentId, $scope.pspAccountId,
                                            hfToken, selectedBrand, cardHolder);

                                        result.then(function (data) { //get redirection url from C# controler
                                            var selectedProduct = window.sessionStorage.getItem("selectedProduct");
                                            var finishUrl = tseUtil.Url.appendValueToUrl(data.data, "selectedproduct", selectedProduct);
                                            window.location.href = finishUrl;
                                        }).catch(function (err) { //on exception, redirect on error page
                                            $scope.saveSentryData(
                                                "Error",
                                                 "",
                                                err,
                                                $scope.bkgData.request.requestId,
                                                $scope.bkgData.bookingRequest.purchaseId,
                                                $scope.bkgData.bookingResponse.paymentId,
                                                $scope.bkgData.bookingResponse.paymentMethod.paymentMethodReference,
                                                $scope.bkgData.bookingResponse.bookingId);
                                            window.location.href = window.site.currentAirRequest.finishErrorUrl;
                                        });
                                    }
                                    else {
                                        //redirect to error page because postTotal failed
                                        document.location.href = "/airpaymentresponse/" + $scope.bkgData.request.requestId, + "/" + $scope.bkgData.bookingResponse.bookingId + "?posttotalfailed=1";
                                    }
                                });
                            }
                            else {
                                try {
                                    var result = window.Typescript.Services.OrderServiceService.ProcessOrderAsync($scope.bkgData.request.requestId,
                                        $scope.bkgData.bookingRequest.purchaseId, $scope.bkgData.bookingResponse.bookingId,
                                        $scope.bkgData.bookingResponse.paymentId, $scope.pspAccountId,
                                        hfToken, selectedBrand, cardHolder);

                                    result.then(function (data) { //get redirection url from C# controler
                                        if (data != null) {
                                            window.location.href = data;
                                        }
                                    }).catch(function (err) { //on exception, redirect on error page
                                        $scope.saveSentryData(
                                            "Error",
                                            "",
                                            err,
                                            $scope.bkgData.request.requestId,
                                            $scope.bkgData.bookingRequest.purchaseId,
                                            $scope.bkgData.bookingResponse.paymentId,
                                            $scope.bkgData.bookingResponse.paymentMethod.paymentMethodReference,
                                            $scope.bkgData.bookingResponse.bookingId);
                                        window.location.href = window.site.currentAirRequest.finishErrorUrl;
                                    });
                                }
                                catch (e) {
                                    $scope.saveSentryData(
                                        "Error",
                                        "",
                                        e,
                                        $scope.bkgData.request.requestId,
                                        $scope.bkgData.bookingRequest.purchaseId,
                                        $scope.bkgData.bookingResponse.paymentId,
                                        $scope.bkgData.bookingResponse.paymentMethod.paymentMethodReference,
                                        $scope.bkgData.bookingResponse.bookingId);
                                }
                            }
                        }
                    };


                    var casinoCallBackUrl = '/api/api/orderservice/processCasinoOrder?requestId=' + $scope.bkgData.request.requestId + '&purchaseId=' + $scope.bkgData.bookingRequest.purchaseId + "&bookingId=" + $scope.bkgData.bookingResponse.bookingId + "&paymentId=" + $scope.bkgData.bookingResponse.paymentId + "&pspAccountId=" + $scope.pspAccountId;
                    var casinoErrorCallBackUrl = window.site.currentAirRequest.finishErrorUrl;

                    if (window.site.partnerId == "servair") {
                        var selectedProduct = window.sessionStorage.getItem("selectedProduct");
                        var bookingNumber = $scope.bkgData.bookingResponse.numbers[0].bookingNumber;
                        var originAirportIata = bkgData.purchaseResponse.itineraries[0].origin.airportIata;
                        var destinationAirportIata = bkgData.purchaseResponse.itineraries[0].destination.airportIata;
                        var airportIata = originAirportIata + destinationAirportIata;
                        var token = tseUtil.Cookies.get("lid_servair_token");
                        //public string ProcessServairCasinoOrder(Guid requestId, Guid purchaseId, Guid bookingId, Guid paymentId, Guid pspAccountId,
                        //    string selectedProduct, string bookingNumber, string airportIata, string token)

                        var extraParameters = '&selectedProduct=' + selectedProduct
                            + '&bookingNumber=' + bookingNumber
                            + '&airportIata=' + airportIata
                            + '&token=' + token
                        casinoCallBackUrl = '/api/api/orderservice/processServairCasinoOrder?requestId=' + $scope.bkgData.request.requestId + '&purchaseId=' + $scope.bkgData.bookingRequest.purchaseId + "&bookingId=" + $scope.bkgData.bookingResponse.bookingId
                            + "&paymentId=" + $scope.bkgData.bookingResponse.paymentId + "&pspAccountId="
                            + $scope.pspAccountId + extraParameters;
                        casinoErrorCallBackUrl += '&posttotalfailed=1'
                    }

                    var casinoOptions = {
                        "placeholder": { // placeholder of the input hosted fields
                            "holdername": $i18next.t('simplepayment.cardowner'),
                            "card": $i18next.t('simplepayment.cardnumber'),
                            "expiry": $i18next.t('simplepayment.date'),
                            "cryptogram": $i18next.t('simplepayment.ccv')
                        },
                        "labels": { // label of the hosted fields
                            "cardHolder": "",
                            "brand": "",
                            "card": "",
                            "expiry": "",
                            "validity": "",
                            "submit": submitText,
                        },
                        "submitCallback": casinoCallBackUrl,
                        "errorCallback": function () {
                            $scope.saveSentryData(
                                "Error",
                                "",
                                new Error("Error Callback"),
                                $scope.bkgData.request.requestId,
                                $scope.bkgData.bookingRequest.purchaseId,
                                $scope.bkgData.bookingResponse.paymentId,
                                $scope.bkgData.bookingResponse.paymentMethod.paymentMethodReference,
                                $scope.bkgData.bookingResponse.bookingId);
                            window.location.href = casinoErrorCallBackUrl;
                        }
                    };

                    var currentOptions = '';
                    if ($window.casinoTotalAmount) {
                        currentOptions = casinoOptions;
                    } else {
                        currentOptions = cbOptions;
                    }

                    var BluePayementJS = BluePaymentWidget.default;
                    var blue = new BluePayementJS("payment-form", currentOptions);
                    blue.init();
                    $("<p class='brand-form-group'></p>").insertAfter(".card-form-group");
                    $(".brand-form-group").append($('.brand-container'));
                    //set GRID
                    $(".hosted-fields-form").addClass("row md-gutters");
                    $(".card-form-group").addClass("col-8");
                    $(".brand-form-group").addClass("col-4");
                    $(".expiry-form-group").addClass("col-8 col-sm-4");
                    $(".cvv-form-group").addClass("col-8 col-sm-4");
                    $(".cardholder-form-group").addClass("col-12");
                    $(".blue-widget-submit").addClass("col-12");
                    $(".blue-widget-submit-input").addClass("c-btn-l c-w-100");

                    $window.FLoading({ vAction: 'hide' });

                } catch (e) {
                    $scope.saveSentryData(
                        "Error",
                        "",
                        e,
                        $scope.bkgData.request.requestId,
                        $scope.bkgData.bookingRequest.purchaseId,
                        $scope.bkgData.bookingResponse.paymentId,
                        $scope.bkgData.bookingResponse.paymentMethod.paymentMethodReference,
                        $scope.bkgData.bookingResponse.bookingId);
                }
            };

            var widgetInterval = setInterval(function () {
                try {
                  console.log('BluePaymentWidget : ' + typeof BluePaymentWidget)
                      if (typeof BluePaymentWidget !== 'undefined' && $("#payment-form form").length == 0) {
                          $scope.displayWidgetForm();
                          //required because of FF
                          var formInterval = setInterval(function () {
                              $("#frm-widget").fadeIn();
                              if ($("#frm-widget").is(":visible")) {
                                  clearInterval(formInterval);
                                  $window.FLoading({ vAction: 'hide' });
                              }
                          }, 300);
                          clearInterval(widgetInterval);
                      }
                  } catch (e) {
                      $scope.saveSentryData(
                          "",
                          "TimeOut",
                          e,
                          $scope.bkgData.request.requestId,
                          $scope.bkgData.bookingRequest.purchaseId,
                          $scope.bkgData.bookingResponse.paymentId,
                          $scope.bkgData.bookingResponse.paymentMethod.paymentMethodReference,
                          $scope.bkgData.bookingResponse.bookingId);
                  }
            }, 300);
        }
        else {
            $window.FLoading({ vAction: 'show' });
            $scope.saveSentryData(
                "Error",
                "",
                new Error("bkgData not exist"),
                $scope.bkgData.request.requestId,
                $scope.bkgData.bookingRequest.purchaseId,
                $scope.bkgData.bookingResponse.paymentId,
                $scope.bkgData.bookingResponse.paymentMethod.paymentMethodReference,
                $scope.bkgData.bookingResponse.bookingId);
            $window.location.href = searchUrl;
        }
    }]);